import { Component, OnDestroy, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';
import { NotificationsService, AppNotification } from '../../../core/services/notifications.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit, OnDestroy {
  auth = inject(AuthService);
  notif = inject(NotificationsService);
  private router = inject(Router);

  showPanel = signal(false);

  ngOnInit() {
    this.notif.start();
  }

  ngOnDestroy() {
    // Header verschwindet beim Logout (Shell unmountet) → Stream beenden,
    // damit nach erneutem Login mit frischem Token neu verbunden wird.
    this.notif.stop();
  }

  togglePanel() {
    this.showPanel.update(v => !v);
  }

  openItem(n: AppNotification) {
    this.notif.markRead(n.id);
    this.showPanel.set(false);
    if (n.url) this.router.navigateByUrl(n.url);
  }

  /** Initialen aus dem vollständigen Namen (display_name). */
  get initials(): string {
    const name = this.auth.user()?.display_name ?? '';
    return name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);
  }

  // ── Kategorie → Icon/Farbe (Default: Glocke). Erweiterbar je Modul. ──
  private static readonly DEFAULT_CAT = {
    icon: 'M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9 M13.73 21a2 2 0 0 1-3.46 0',
    color: '#DB9C24', bg: '#FBF1DC',
  };
  private static readonly CAT: Record<string, { icon: string; color: string; bg: string }> = {
    notizen: {
      icon: 'M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z',
      color: '#6A1B9A', bg: '#F3E5F5',
    },
  };
  private cat(c: string) { return HeaderComponent.CAT[c] ?? HeaderComponent.DEFAULT_CAT; }
  catIcon(c: string) { return this.cat(c).icon; }
  catColor(c: string) { return this.cat(c).color; }
  catBg(c: string) { return this.cat(c).bg; }

  /** Relative Zeit. Backend liefert UTC ohne Zeitzonen-Kennung → 'Z' anhängen. */
  formatTime(iso: string): string {
    const utc = /[zZ]|[+-]\d\d:?\d\d$/.test(iso) ? iso : iso + 'Z';
    const d = new Date(utc);
    const diff = (Date.now() - d.getTime()) / 1000; // Sekunden
    if (diff < 60) return 'gerade eben';
    if (diff < 3600) return `vor ${Math.floor(diff / 60)} Min`;
    if (diff < 86400) return `vor ${Math.floor(diff / 3600)} Std`;
    const yest = new Date();
    yest.setDate(yest.getDate() - 1);
    if (d.toDateString() === yest.toDateString()) return 'Gestern';
    return d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: '2-digit' });
  }
}
